<template>
    <el-dialog title="煤种数据维护" :visible="visible" :show="show" width="80%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="140px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="煤矿名称" class="input" prop="cocalName" >
                        <el-input v-model="ruleForm.cocalName" autocomplete="off" placeholder="煤炭名称" readonly />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="煤种类型" class="input" prop="cocalType" >
                        <el-select v-model="ruleForm.cocalType" style="width:100%" readonly>
                            <el-option v-for="(item,i) in cocalTypeList" :label="item.indexName" :key="i" :value="item.indexName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="收到基低发热量" class="input" prop="hots" >
                        <el-input v-model.number="ruleForm.hots" autocomplete="off" placeholder="热值" style="width:90%" readonly></el-input>大卡
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="采购价（含税）" class="input" prop="unitPrice" >
                        <el-input v-model="ruleForm.unitPrice" autocomplete="off" placeholder="采购价（含税）" @change="getPrice('1')" style="width:90%" readonly></el-input>元/吨
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="采购价（不含税）" class="input" prop="bhsUnitPrice" >
                        <el-input v-model="ruleForm.bhsUnitPrice" autocomplete="off" placeholder="不采购价（含税）" @change="getPrice('2')" readonly style="width:90%" readonly></el-input>元/吨
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="硫分" class="input" prop="liufen" >
                        <el-input v-model="ruleForm.liufen" autocomplete="off" placeholder="请输入..." style="width:90%" readonly></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="到场地" class="input" prop="arriveStation" >
                        <el-select v-model="ruleForm.arriveStation" style="width:100%" @change="changeStation()">
                            <el-option v-for="(item,i) in stationList" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item >
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="收到基灰分" class="input" prop="sdjhScore" >
                        <el-input v-model="ruleForm.sdjhScore" autocomplete="off" placeholder="收到基灰分" style="width:90%" readonly></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="不含税运费" class="input" prop="bhsPrice" >
                        <el-input v-model.number="ruleForm.bhsPrice" autocomplete="off" placeholder="不含税运费" @change="caluateFreightPrice('2')"  ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="含税运费" class="input" prop="hsPrice" >
                        <el-input v-model.number="ruleForm.hsPrice" autocomplete="off" placeholder="含税运费"  @change="caluateFreightPrice('1')"></el-input>
                    </el-form-item>
                </el-col>


                <el-col :span="8">
                    <el-form-item label="全水分" class="input" prop="quanshui" >
                        <el-input v-model="ruleForm.quanshui" autocomplete="off" placeholder="全水分" style="width:90%" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="库存（吨）" class="input" prop="stock" >
                        <el-input v-model.number="ruleForm.stock" autocomplete="off" placeholder="库存" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item >
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="收到基挥发分" class="input" prop="kqgzjhfScore" >
                        <el-input v-model="ruleForm.kqgzjhfScore" autocomplete="off" placeholder="收到基挥发分" style="width:90%" readonly></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="是否破碎" class="input" prop="isBroken" >
                        <el-radio v-model="ruleForm.isBroken" label="是" @change="changeBrokenType('1')" readonly></el-radio>
                        <el-radio v-model="ruleForm.isBroken" label="否" @change="changeBrokenType('2')" readonly></el-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item >
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="空气干燥基固定碳" class="input" prop="kqgzjgdt" >
                        <el-input v-model="ruleForm.kqgzjgdt" autocomplete="off" placeholder="空气干燥基固定碳" style="width:90%" readonly></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="破碎费用" class="input" prop="brokenPrice" >
                        <el-input v-model.number="ruleForm.brokenPrice" autocomplete="off" placeholder="破碎费用" :disabled="ruleForm.isBroken==='否'" style="width:90%" readonly ></el-input>  元
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="降热值" class="input" prop="fallHots" >
                        <el-input v-model.number="ruleForm.fallHots" autocomplete="off" placeholder="降热值" :disabled="ruleForm.isBroken==='否'" style="width:90%" readonly></el-input> 卡
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="焦渣特征" class="input" prop="jztz" >
                        <el-input v-model="ruleForm.jztz" autocomplete="off" placeholder="焦渣特征" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initStationList();
                    this.initCocalTypeList();
                    this.initPortList();
                    this.ruleForm.brokenPrice = '0';
                    this.getBaseCocalConfig();
                    this.orgType = this.$storage.get("orgType");
                    if (this.orgType!='3'){
                        this.rules.portName = [{ required: true, message: '请选择港口', trigger: 'blur' }];
                        this.rules.trainPrice = [{ required: true, message: '请输入铁路运费', trigger: 'blur' }];
                    }else{
                        this.rules.trainPrice = [];
                        this.rules.portName = [];
                    }
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
            /*"ruleForm.notAddPointPrice"(){
                console.log(this.ruleForm.notAddPointPrice);
            }*/
        },
        data(){
            var validateNumber = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入数字'));
                }
                setTimeout(() => {
                    if (!Number.isNaN(value) && /^-?\d+(\.\d+)?$/.test(value)) {
                        callback();
                    } else {
                        callback(new Error('请输入有效的数字或小数'));
                    }
                }, 100);
            };
            return{
                stationList:[],
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    //必填项
                    bhsPrice:'',
                    cocalName:'',
                    personName:'',
                    mobile:'',
                    cocalType:'',
                    hots:null,
                    liufen:'',
                    unitPrice:null,
                    isBroken:'',
                    stock:null,
                    arriveStation:'',
                    hsPrice:null,
                    stationPrice:null,
                    //非必填
                    quanshui:'',
                    sdjhScore:'',
                    jztz:'',
                    kqgzjhfScore:'',
                    brokenPrice:null,
                    bhsUnitPrice:0,
                    portName:'',
                    bhsStationPrice:0,
                },
                orgType:'',
                rules:{
                    cocalName:[{ required: true, message: '请输入煤矿名称', trigger: 'blur' }],
//                    personName:[{ required: true, message: '请输入联系人', trigger: 'blur' }],
//                    mobile:[{ required: true, message: '请输入联系方式', trigger: 'blur' }],
                    cocalType:[{ required: true, message: '请选择煤炭类型', trigger: 'blur' }],
                    isBroken:[{ required: true, message: '请选择是否破碎', trigger: 'blur' }],
                    hots:[{ required: true, message: '请输入热值', trigger: 'blur' },
                        {type:'number', message: '请输入数据', trigger: 'blur' }],
                    liufen:[
                        { required: true, message: '请输入硫分', trigger: 'blur' },
                        { validator: validateNumber, trigger: 'blur' }
                    ],
                    unitPrice:[
                        { required: true, message: '请输入含税单价', trigger: 'blur' },
                        { validator:validateNumber, trigger: 'blur' }],
                    stock:[
                        { required: true, message: '请输入库存', trigger: 'blur' },
                        { type:'number', message: '输入内容不是有效的数字', trigger: 'blur' }],
                    arriveStation:[{ required: true, message: '请输入到场地', trigger: 'blur' }],
                    hsPrice:[
                        { required: true, message: '请输入含税运费', trigger: 'blur' },
                        { validator:validateNumber, trigger: 'blur' }],
                    stationPrice:[
                        { required: true, message: '请输入场地费', trigger: 'blur' },
                        { required: true,type:'number', message: '输入内容不是有效的数字', trigger: 'blur' }],
                    portName:[],
                },
                cocalTypeList:[],
                baseCocalConfig:{},
                portList:[],
                fallHots: [
                    {
                        required: false,
                        validator: (rule, value, callback) => {
                            if (this.ruleForm.isBroken === '是' && ( this.ruleForm.fallHots=='' ||  this.ruleForm.fallHots==0)) {
                                callback(new Error('请输入降热值！'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                brokenPrice: [
                    {
                        required: false,
                        validator: (rule, value, callback) => {
                            if (this.ruleForm.isBroken === '是' && ( this.ruleForm.brokenPrice=='' ||  this.ruleForm.brokenPrice==0)) {
                                callback(new Error('请输入破碎费！'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            }
        },
        methods:{
            changeBrokenType(type){
//                alert(type);
                if (this.type=='2'){
                    this.ruleForm.brokenPrice = 0;
                    this.ruleForm.fallHots = 0;
                }else{
                    this.ruleForm.brokenPrice = null;
                    this.ruleForm.fallHots = null;
                }
            },
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
                this.baseCocalConfig = {};
            },
            commit(){

                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`cocalTemplate/`+"save":this.url+`cocalTemplate/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: data.msg,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },

            initCocalTypeList(){
                let params = {
                    page: 1,
                    limit: 30,
                    sort: 'id',
                }
                params['dicCode'] = "cocal_type"//编码名字
                params['dicName'] = "煤种类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.cocalTypeList = data.data.list;
                    }
                });
            },
            getPrice(type){
                if (type=='2'){
                    let price = parseInt(this.ruleForm.bhsUnitPrice);
                    let unitPrice = price * this.baseCocalConfig.taxPoint;
                    this.ruleForm.unitPrice = unitPrice.toFixed(1);
                }else{
                    let price = this.ruleForm.unitPrice;
                    let bhsUnitPrice = price / this.baseCocalConfig.taxPoint;
                    this.ruleForm.bhsUnitPrice = bhsUnitPrice.toFixed(1);
                }
            },
            caluateFreightPrice(type){
                if (type=='2'){
                    let price = parseInt(this.ruleForm.bhsPrice);
                    let unitPrice = price / this.baseCocalConfig.freightPoint;
                    this.ruleForm.hsPrice = unitPrice.toFixed(1);
                }else{
                    let price = this.ruleForm.hsPrice;
                    let bhsPrice = price * this.baseCocalConfig.freightPoint;
                    this.ruleForm.bhsPrice = bhsPrice.toFixed(1);
                }
            },
            getBaseCocalConfig(){
                this.$http({
                    url: "baseCocalConfig/list",
                    method: "get",
                }).then(({ data }) => {
                    let arr = data.data;
                    if (arr.length>0){
                        this.baseCocalConfig = arr[0];
                    }
                });
            },
            initPortList(){
                this.$http({
                    url: "port/list",
                    method: "get",
                }).then(({ data }) => {
                    //let arr = data.data;
                    this.portList = data.data;
                });
            },
            changePort(){
                let port = this.portList.find(port=>{
                    return port.portName == this.ruleForm.portName;
                })
                this.ruleForm.gangzaPrice = port.portPrice;
            },
            initStationList(){
                this.$http({
                    url: "basePriceConfig/getStationListByCompanyId",
                    method: "get",
                }).then(({ data }) => {
                    //let arr = data.data;
                    this.stationList = data.data;
                    //this.portList = data.data;
                });
            },
            changeStation(){
                let obj = this.stationList.find((t)=>{
                    return t.name == this.ruleForm.arriveStation;
                })
                this.ruleForm.stationPrice = obj.price;
                this.ruleForm.bhsStationPrice = obj.bhsPrice;
            }



        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
</style>